const map = {
	"./images/serviceDevelopment/mobileweb/devlopment3@2x.jpg": 94418,
	"./images/serviceDevelopment/operation/devlopment4@2x.jpg": 31790,
	"./images/serviceDevelopment/research/devlopment1@2x.jpg": 63303,
	"./images/serviceDevelopment/uiux/devlopment2@2x.jpg": 34376
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64711;